import { TOGGLE_SELECT_LEAD, DESELECT_LEAD } from '../actions';

export default function(state = [], action) {
  switch (action.type) {
  case TOGGLE_SELECT_LEAD: {
    return action.payload.leads;
  }
  case DESELECT_LEAD: {
    return state.filter(lead => action.payload !== lead[0]);
  }
  default: {
    return state;
  }
  }
}
